import { ReactElement, useMemo, memo } from 'react';

import { sourceImportType } from '~constants/sourceImportType';

import { SourceImportTypeInfoProps } from './types';
import {
  SourceImportTypeInfoContainer,
  SourceImportTypeInfoText,
  SourceImportTypeInfoImage,
  SourceImportTypeInfoFlexTypoText,
} from './styles';

const SourceImportTypeInfo = ({
  sourceImportTypeId,
}: SourceImportTypeInfoProps): ReactElement => {
  const typeId = useMemo(
    () =>
      sourceImportTypeId !== null &&
      sourceImportTypeId < sourceImportType.length
        ? sourceImportTypeId
        : 1,
    [sourceImportTypeId],
  );

  return (
    <SourceImportTypeInfoContainer>
      <SourceImportTypeInfoText>
        <SourceImportTypeInfoImage
          src={sourceImportType[typeId].image.url}
          alt={sourceImportType[typeId].image.alt}
        />

        {typeId !== 5 && sourceImportType[typeId].name}
      </SourceImportTypeInfoText>

      {typeId === 5 && (
        <SourceImportTypeInfoFlexTypoText>
          {sourceImportType[typeId].name}
        </SourceImportTypeInfoFlexTypoText>
      )}
    </SourceImportTypeInfoContainer>
  );
};

export default memo(SourceImportTypeInfo);
